export default "<a href=\"tel:{{ cellValue }}\">{{ cellValue }}</a>\r\n";